export enum StockLocation {
  POSTOUT = 'POSTOUT',
  WAREHOUSE = 'WAREHOUSE',
  STORE = 'STORE',
  SUPPLIER = 'SUPPLIER',
  PREORDER = 'PREORDER',
  INFOPOINT_FALLBACK = 'INFOPOINT_FALLBACK',
  IN_STORE = 'IN_STORE',
  IN_OTHER_STORE = 'IN_OTHER_STORE',
}
